
const spfction = {
  install(Vue, options) {
    
    //判断字符串是否在数组内
    Vue.prototype.in_configs = function (id) {
      let arr = [],array = JSON.parse(sessionStorage.configs);
      for (let i = 0; i < array.length; i++) {
        arr.push(array[i].id);
      }
      if (arr.indexOf(id) > -1) return true;
      return false;
    }

    //定义指令
    Vue.directive("uname", {
      bind() {
        console.log("bind"); // 只会调用一次
      },
      update(el, binding, vnode) {
        console.log(el);
        console.log(binding);
        console.log(vnode);
      },
    })
  }
}

if (typeof window !== 'undefind' && window.Vue) {
  window.Vue.use(spfction);
}

export default spfction



// WEBPACK FOOTER //
// ./src/spfction.js